import React from 'react'
import { Descriptions, Divider } from 'antd'
import { EmployeeData } from '../../../services/api/employees'
import { isMale } from '../../../utils/types'
import { ManOutlined, WomanOutlined } from '@ant-design/icons'
import { Documents } from './Documents'
import { companyPath } from '../../../routes/paths'
import { Link } from 'react-router-dom'
import locales from '../../../assets/locales.json'
import { safePrintValue } from '../../../utils'
import { displayDate } from '../../../utils/formatter'

type Props = {
  employee: EmployeeData
}

export const Card: React.FunctionComponent<Props> = ({ employee }) => {
  const countries = locales.ru.countries

  return (
    <>
      <Descriptions bordered column={1}>
        <Descriptions.Item label="ФИО сотрудника">
          {employee.firstNameRu} {employee.lastNameRu} {employee.middleNameRu}
          <Divider />
          {employee.firstNameEn} {employee.lastNameEn}
        </Descriptions.Item>
        <Descriptions.Item label="Компания">
          <Link to={companyPath(employee.company.id)}>
            {employee.company.name}
          </Link>
        </Descriptions.Item>
        <Descriptions.Item label="Пол">
          {isMale(employee.gender) ? <ManOutlined /> : <WomanOutlined />}
        </Descriptions.Item>
        <Descriptions.Item label="Дата рождения">
          {displayDate(employee.birthdate)}
        </Descriptions.Item>
        <Descriptions.Item label="Общая информация">
          <strong>Гражданство:</strong>{' '}
          {countries[employee.countryCode as keyof typeof countries]}
          <br />
          <strong>Телефон:</strong> {safePrintValue(employee.phoneNumber)}
          <br />
          <strong>Email:</strong> {safePrintValue(employee.email)}
        </Descriptions.Item>
        <Descriptions.Item label="Документы сотрудника">
          <Documents employeeId={employee.id} />
        </Descriptions.Item>
      </Descriptions>
    </>
  )
}
